import { useDevCycleClient, useIsDevCycleInitialized } from '@devcycle/react-client-sdk';
import { useEffect } from 'react';
import { syncDevCycleFlagsToPostHog } from '@/integrations/devcyclePosthogSync';

const VARIABLE_UPDATED_EVENT = 'variableUpdated:*';

/**
 * Keeps PostHog `dvc_*` properties in sync with DevCycle-evaluated registry flags.
 * Registers event super properties always; person properties only when identified.
 */
const useSyncDevCycleFlagsToPostHog = () => {
  const client = useDevCycleClient();
  const isInitialized = useIsDevCycleInitialized();

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    // DevCycle emits once per changed variable; the sync dedupes, so extra calls are no-ops.
    const sync = () => {
      syncDevCycleFlagsToPostHog(client);
    };

    sync();
    client.subscribe(VARIABLE_UPDATED_EVENT, sync);

    return () => {
      client.unsubscribe(VARIABLE_UPDATED_EVENT, sync);
    };
  }, [client, isInitialized]);
};

export default useSyncDevCycleFlagsToPostHog;
